export default __webpack_public_path__ + "static/media/992.97d27765.gif";